import { useMemo } from 'react'
import classnames from 'classnames'

import { invoicePriceFormatter } from 'shared/utils'
import { getTaxationItems, getTaxesNames, getTaxesTotalNumber, getCurrentTaxTranslatedName } from '../../helpers'

import styles from './styles.module.scss'

const groupInvoices = (invoiceItems = []) => {
    const groups = {}

    invoiceItems.forEach(item => {
        const { serviceStartDate } = item
        if (!groups[serviceStartDate]) {
            groups[serviceStartDate] = []
        }

        groups[serviceStartDate].push(item)
    })

    return Object.entries(groups)
}

const InvoiceSection = ({ invoice }) => {
    const groups = useMemo(() => groupInvoices(invoice.invoiceItems), [invoice])

    const taxationItems = getTaxationItems(invoice.invoiceItems)

    return (
        <>
            {groups.map(([startDate, items]) => (
                <div key={startDate} className={styles.review}>
                    <div className={classnames('d-flex', 'justify-content-between', styles.reviewHeader)}>
                        <span className={classnames('font-weight-bold', styles.title)}>
                            <T>subscription.purchase.invoice.title</T>
                        </span>
                    </div>
                    {items.map((line, i) => (
                        <div
                            key={i}
                            className={classnames(
                                'd-flex justify-content-between',
                                styles.reviewLine,
                                styles.reviewRow
                            )}>
                            <span>{line.chargeName}</span>
                            <span>{invoicePriceFormatter(line.amountWithoutTax)}</span>
                        </div>
                    ))}
                </div>
            ))}

            <div className={classnames('col-12', 'col-sm-9', 'text-sm-right', 'mt-2', styles.reviewTotal)}>
                {getTaxesNames(taxationItems).map((name, index) => (
                    <div className="row no-gutter mt-2" key={index}>
                        <div className="col-7 col-sm-9 ">
                            <span>{getCurrentTaxTranslatedName(name)}</span>
                        </div>
                        <div className="col-5 col-sm-3 text-right">
                            <span>{invoicePriceFormatter(getTaxesTotalNumber(name, taxationItems))}</span>
                        </div>
                    </div>
                ))}
                <div className={classnames('row', 'no-gutter', 'mt-3', 'font-weight-bold', styles.total)}>
                    <div className="col-8 col-sm-9">
                        <T>subscription.purchase.invoice.total</T>{' '}
                    </div>
                    <div className="col-4 col-sm-3 text-right">
                        {invoicePriceFormatter(invoice.tax + invoice.amountWithoutTax)}
                    </div>
                </div>
            </div>
        </>
    )
}

export default InvoiceSection
